module.exports = __webpack_public_path__ + "fonts/fa-brands-400.e2ca6541.eot";